<template>
  <div
    v-lazy-container="{ selector: 'img' }"
    :class="isSideCard ? 'shadow-sm' : 'shadow-md'"
    class="relative rounded-3xl h-80 shrink-0 flex justify-center bg-white"
  >
    <img
      :data-src="getAssetUrl(review.petPhoto)"
      :alt="$t('homepage.clients-pet-alt')"
      :class="{ '!opacity-50': isSideCard }"
      class="absolute -translate-y-16 md:-translate-y-20 md:top-2 rounded-3xl w-24 aspect-1 z-10"
    />
    <div
      v-if="isSideCard"
      class="absolute inset-0 bg-white/50 rounded-3xl"
    />
    <div class="pt-14 md:pt-10 pb-10 px-10 text-left">
      <div class="flex justify-between items-center">
        <div class="space-x-1">
          <fa
            v-for="star in 5"
            :key="star"
            :icon="['fas', 'star']"
            class="text-bubblegum-500"
          />
        </div>
        <p
          v-if="!hideDate"
          class="text-neutral-600 text-sm"
        >
          {{ reviewedOn }}
        </p>
      </div>
      <h3 class="text-ocean-950 font-bold">
        {{ review.author }}
      </h3>
      <p class="mt-6 text-ocean-950 leading-5 overflow-hidden line-clamp-[8]">
        {{ review.review }}
      </p>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';

import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterCarouselReviewCard',

  props: {
    hideDate: {
      type: Boolean,
      default: false,
    },
    isSideCard: {
      type: Boolean,
      default: false,
    },
    review: {
      type: Object,
      required: true,
    },
  },

  computed: {
    reviewedOn() {
      return DateTime.fromISO(this.review.createdAt)
        .toFormat('LLL d');
    },
  },

  methods: {
    getAssetUrl,
  },
};
</script>
